import { useCallback } from "react";
import { Button, useModal } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";

/**
 * Asks before a pickup location group's route creates duplicates: its taken
 * stops (a window whose job is routed, in progress or another group's) get a
 * new job only once the dispatcher agrees. Resolves to `false` when declined.
 */
export function useConfirmDuplicates() {
  const { openModal, closeModal } = useModal();
  const t = useT();

  return useCallback(
    (count: number) =>
      new Promise<boolean>((resolve) => {
        const answer = (yes: boolean) => {
          closeModal(modalId);
          resolve(yes);
        };
        const modalId = openModal({
          size: "lg",
          title: t(Namespace.Routes, "duplicatesConfirmTitle"),
          body: <span>{t(Namespace.Routes, "duplicatesConfirmBody", { count })}</span>,
          footer: (
            <div className="flex w-full justify-end gap-2">
              <Button variant="outline" onClick={() => answer(false)}>
                {t(Namespace.Common, "cancel")}
              </Button>
              <Button variant="opacityBlueWithOutline" onClick={() => answer(true)}>
                {t(Namespace.Routes, "duplicatesConfirm")}
              </Button>
            </div>
          ),
          onClose: () => resolve(false),
        });
      }),
    [openModal, closeModal, t],
  );
}
